<template>
  <router-link
    v-bind="attrs"
    v-tooltip="{ value: tooltip, showDelay: 100 }"
    :to="resolved_to"
    :replace="replace"
    :class="{
      'text-blue-500': highlight,
      'hover:underline': highlight || !hide_underline,
      'font-semibold': bold_styling,
    }"
  >
    <slot />
  </router-link>
</template>

<script setup>
import { computed, useAttrs } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  to: {
    type: [String, Object],
    required: true,
  },
  replace: {
    type: Boolean,
  },
  highlight: {
    type: Boolean,
  },
  hide_underline: {
    type: Boolean,
  },
  bold_styling: {
    type: Boolean,
  },
  tooltip: {
    type: String,
    default: null,
  },
});

const route = useRoute();
const attrs = useAttrs();

const staticParams = {};
if (route.query._profile_id && route.query._profile_type) {
  staticParams._profile_id = route.query._profile_id;
  staticParams._profile_type = route.query._profile_type;
}

const resolved_to = computed(() => {
  const { to } = props;

  if (typeof to === 'object') {
    return {
      ...to,
      query: {
        ...staticParams,
        ...to.query,
      },
    };
  }

  return to;
});
</script>
